import React, { ReactNode, useState } from 'react';
import { Modal, ModalContent, ModalFooter, ModalHeader, RegularButton } from 'fronton-react';
import { BenefitItem } from '../benefit-item';
import { benefitsDb } from './benefits-db';
import { benefitsListStyles } from './styles';

export const BenefitList = () => {
	const [currentBenefit, setCurrentBenefit] = useState(0);
	const [openModal, setOpenModal] = useState(false);

	const toggleModal = () => setOpenModal(!openModal);

	const onBenefitClick = id => {
		setCurrentBenefit(id);
		toggleModal();
	};

	const scrollToForm = () => {
		document.getElementById('applicationForm').scrollIntoView({
			behavior: 'smooth',
		});
	};
	const scrollAndClose = () => {
		scrollToForm();
		toggleModal();
	};
	return (
		<>
			<div className={benefitsListStyles}>
				{benefitsDb.map((el, index) => (
					<BenefitItem {...el} id={index} onClick={onBenefitClick} key={el.text} />
				))}
			</div>
			<Modal modalID="menu" show={openModal} onClose={toggleModal} size="s">
				<ModalHeader
					title={(benefitsDb[currentBenefit].titleModal as unknown) as string & ReactNode}
				/>
				<ModalContent data-qa="benefit-ModalContent">
					{benefitsDb[currentBenefit]?.modalText}
				</ModalContent>
				<ModalFooter>
					<RegularButton size="l" variant="primary" wide onClick={scrollAndClose}>
						Записаться
					</RegularButton>
				</ModalFooter>
			</Modal>
		</>
	);
};
